import { MouseEventHandler } from "react";
import { useDispatch } from "react-redux";

import { CaseAdmin, CaseDocumentAdmin } from "pwapi";

import { uploadAdminCaseDocument } from "shared/actions/admin/adminDocumentsActions";
import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";

import DocumentsForm from "./DocumentsForm";

type UploadDocumentsFormProps = {
  adminCase?: CaseAdminDetail;
  onClose: MouseEventHandler<HTMLButtonElement>;
};

const UploadDocumentsForm = ({
  onClose,
  adminCase,
}: UploadDocumentsFormProps) => {
  const dispatch = useDispatch();

  const handleOnSubmit = (values: any) => {
    const submitForm = new FormData();
    submitForm.append("file_uploaded", values.file);
    values.case?.id && submitForm.append("case_id", `${values.case.id}`);
    values.category && submitForm.append("category", values.category);
    submitForm.append("status", CaseDocumentAdmin.status.PENDING);
    submitForm.append("name", values.name);

    dispatch(uploadAdminCaseDocument(submitForm, onClose, values.case));
  };

  return (
    <DocumentsForm
      document={{
        case: adminCase as CaseAdmin,
        name: "",
        //@ts-ignore
        category: undefined,
      }}
      onSubmit={handleOnSubmit}
      onClose={onClose}
      isUploading
      hasFlatCase={!!adminCase}
    />
  );
};

export default UploadDocumentsForm;
